import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeUpdateBtnDisabled, changePlanScreensDataToSend } from '../../../../components/store/admin/slice';
import PaymentRow from "./PaymentRow/PaymentRow";
import { StyledOnePaymentWrapper } from './OnePayment.styled';

const OnePayment = ({ amount, date, status, months, planId }) => {
    const dateObj = new Date(date);
    const currentMainMonth = dateObj.getMonth() + 1;
    const currentMainYear = dateObj.getFullYear();
    const currentMainDay = dateObj.getDate();

    const dispatch = useDispatch();
    const [showPayments, setShowPayments] = useState(false);
    const [installment, setInstallment] = useState({
        planId: planId,
        generalAmount: amount,
        mainDate: {
            value: `${currentMainYear}-${currentMainMonth}-${currentMainDay}`,
            label: `${currentMainDay}/${currentMainMonth}/${currentMainYear}`
        },
        months: months
    });
    const [dataToSend, setDataToSend] = useState({})

    const closePayments = () => setShowPayments(false);

    //handling inputs
    const onMainInputChange = e => {
        setInstallment({
            ...installment,
            generalAmount: e.target.value
        });
        setShowPayments(true);     
    };

    const onSubInputChange = e => {
        const targ = e.target;
        setInstallment({
            ...installment,
            months: {
                ...installment.months,
                [targ.name]: {
                    ...installment.months[targ.name],
                    sum: targ.value
                }
            }
        });
    };

    const onMainDropdownChange = e => {
        setInstallment({
            ...installment,
            mainDate: e
        });
        setShowPayments(true);     
    };

    const onSubDropdownChange = e => {
        setInstallment({
            ...installment,
            months: {
                ...installment.months,
                [e.name]: {
                    ...installment.months[e.name],
                    parsedDate: e
                }
            }
        });
    };

    const validation = (generalSum, ...args) => {
        const reducer = (sum, currentValue) => +sum + +currentValue;
        const total = args[0]?.reduce(reducer);
        if (generalSum == total) dispatch(changeUpdateBtnDisabled(false));
        else dispatch(changeUpdateBtnDisabled(true));
    };

    const createMonthsArr = monthsObj => {
        const monthsArr = Object.keys(monthsObj).map(item => {
            const dateObj = new Date(monthsObj[item].parsedDate.value);
            const currentMonth = dateObj.getMonth() + 1;
            const currentYear = dateObj.getFullYear();
            return {
                month: currentMonth,
                year: currentYear,
                sum: monthsObj[item].sum
            };
        });
        return monthsArr
    };

    useEffect(() => {
        setDataToSend({
            paymentDetailsToUpdate: [
                {
                    PaymentPlanDetailID: installment.planId,
                    Amount: installment.generalAmount,
                    ChargeDate: `${installment.mainDate.value} 00:00:00`,
                    months: createMonthsArr(installment.months)           
                }
            ] 
        })
    }, [installment]);

    useEffect(() => {
        dispatch(changePlanScreensDataToSend(dataToSend))
    }, [dataToSend]);

    useEffect(() => {
        validation(installment.generalAmount, Object.keys(installment.months).map(item => installment.months[item].sum))      
    }, [installment]);

    return (
        <StyledOnePaymentWrapper>
            <PaymentRow 
                sum={installment.generalAmount}
                date={installment.mainDate}
                initialDate={date}
                disabled={status === 2}
                onInputChange={onMainInputChange}
                onDropdownChange={onMainDropdownChange}
            />

            {showPayments && (
                <div className="inner-payments-wrapper">
                    <span
                        className='close-btn'
                        onClick={closePayments}
                    >
                        &#215;
                    </span>
                    {Object.keys(installment.months).map((item, i) => {
                        const payment = installment.months[item];
                        return (
                            <PaymentRow 
                                key={i} 
                                inputName={item}
                                sum={payment.sum}
                                date={payment.parsedDate}
                                initialDate={payment.date}
                                onInputChange={onSubInputChange}
                                onDropdownChange={onSubDropdownChange}
                            />
                        )
                    })}
                </div>
            )}
        </StyledOnePaymentWrapper>
    );
};

export default OnePayment;
